import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import "./AutocompleteComponent.css";

function AutocompleteComponent(props) {
    const id = props.id;
    const input = props.handler.form[id];
    const label = input.label;
    const options = React.useMemo(() => props.options || [], [props.options]);

    const [error, setError] = React.useState(input.error);
    const [isFocus, setFocus] = React.useState(false);
    const [selectedOption, setSelectedOption] = React.useState(null);
    const [valueText, setValueText] = React.useState(input.valueText || "");

    React.useEffect(() => {
        const hasValue = input.value !== undefined && input.value !== null && input.value !== "";
        const matchedOption = hasValue
            ? options.find((item) => String(item.value) === String(input.value)) || null
            : null;

        if (matchedOption) {
            setSelectedOption(matchedOption);
            setValueText((previous) => (previous !== matchedOption.label ? matchedOption.label : previous));
            return;
        }

        if (!hasValue) {
            setSelectedOption(null);
            setValueText((previous) => (previous !== "" ? "" : previous));
            return;
        }

        setSelectedOption(null);
        const nextValueText = input.valueText || "";
        setValueText((previous) => (previous !== nextValueText ? nextValueText : previous));
    }, [input.value, input.valueText, options]);

    React.useEffect(() => {
        setError((previous) => (previous !== input.error ? input.error : previous));
    }, [input.error]);

    const onChange = (_event, option) => {
        setSelectedOption(option || null);
        setValueText(option?.label || "");
        if (props.onChange) props.onChange(option?.value ?? "", option || null);
    };

    const onInputChange = (_event, nextInputValue, reason) => {
        setValueText(nextInputValue ?? "");
        if (reason === "clear") {
            setSelectedOption(null);
        }
    };

    const onBlur = () => {
        setFocus(false);
        const value = selectedOption ? selectedOption.value : "";
        props.handler.setValue(id, value);
        props.handler.setValueText(id, valueText);
        let nextError = props.handler.getErrorByField(input);
        setError(nextError);
        props.handler.setError(id, nextError);

        if (props.onBlur) props.onBlur(value);
    };

    const onFocus = () => {
        setFocus(true);
    };

    return (
        <div className="content-autocomplete">
            <Autocomplete
                className={`autocomplete ${
                    isFocus && (!input.disabled && !props.disabled)
                        ? "autocompleteFocus"
                        : error && (!input.disabled && !props.disabled)
                        ? "autocompleteError"
                        : selectedOption && (!input.disabled && !props.disabled)
                        ? "autocompleteValid"
                        : ""
                }`}
                options={options}
                value={selectedOption}
                inputValue={valueText}
                onChange={onChange}
                onInputChange={onInputChange}
                onBlur={onBlur}
                onFocus={onFocus}
                getOptionLabel={(option) => option?.label?.toString() || ""}
                isOptionEqualToValue={(option, value) => String(option?.value) === String(value?.value)}
                disabled={input.disabled || props.disabled}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={
                            label +
                            (input.options && input.options.validation && input.options.validation.indexOf("required") > -1
                                ? " *"
                                : "")
                        }
                        helperText={error && !isFocus ? error : input.textHelper}
                        inputProps={{
                            ...params.inputProps,
                            name:
                                label +
                                (input.options && input.options.validation && input.options.validation.indexOf("required") > -1
                                    ? " *"
                                    : ""),
                            id: props.name,
                        }}
                    />
                )}
            />
        </div>
    );
}

export default AutocompleteComponent;
